import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { MaestroModel } from '../maestro.model';
import { UsuarioService } from '../../services/seguridad/usuario.service';


export class Usuario extends MaestroModel {

    public static RECORD_NAME = 'usuarios';
    public static CODIGO_REGISTRO = 'usuario';
    public static CODIGO_MODULO = 'seguridad';
    public static NOMBRE_PLURAL = 'Usuarios';
    public static NOMBRE_SINGULAR = 'Usuario';

    public static TIPOS = [
        { valor: 1, nombre: 'Administrador' },
        { valor: 2, nombre: 'Empresa' },
        { valor: 3, nombre: 'Sucursal' },
        { valor: 4, nombre: 'Boca' },
    ]

    public static TIPO_ADMINISTRADOR = 1;
    public static TIPO_EMPRESA = 2;
    public static TIPO_SUCURSAL = 3;
    public static TIPO_BOCA = 4;

    private _codigo: string;
    private _contrasenha: string;
    private _idGrupoAcceso: number;
    private _nombreGrupoAcceso: string;
    private _idEmpresa: number;
    private _nombreEmpresa: string;
    private _idSucursal: number;
    private _nombreSucursal: string;
    private _tipo: number;
    private _super: boolean;
    private _resetear: boolean;

    public static ENABLE_FIELDS: string[] = ['tipo'];
    public static DISABLE_FIELDS: string[] = ['tipo'];

    constructor() {
        super();
        this._super = false;
        this._resetear = true;
        this._tipo = Usuario.TIPO_EMPRESA;
    }

    public set codigo( codigo: string ) { this._codigo = codigo };
    public get codigo(): string { return this._codigo };

    public set contrasenha( contrasenha: string ) { this._contrasenha = contrasenha };
    public get contrasenha(): string { return this._contrasenha };

    public set idGrupoAcceso( idGrupoAcceso: number ) { this._idGrupoAcceso = idGrupoAcceso };
    public get idGrupoAcceso(): number { return this._idGrupoAcceso }

    public set nombreGrupoAcceso( nombreGrupoAcceso: string ) { this._nombreGrupoAcceso = nombreGrupoAcceso };
    public get nombreGrupoAcceso(): string { return this._nombreGrupoAcceso };

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa };
    public get idEmpresa(): number { return this._idEmpresa }

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa };
    public get nombreEmpresa(): string { return this._nombreEmpresa }

    public set idSucursal( idSucursal: number ) { this._idSucursal = idSucursal };
    public get idSucursal(): number { return this._idSucursal }

    public set nombreSucursal( nombreSucursal: string ) { this._nombreSucursal = nombreSucursal };
    public get nombreSucursal(): string { return this._nombreSucursal }

    public set tipo( tipo: number ) { this._tipo = tipo };
    public get tipo(): number { return this._tipo }

    public set super( esSuper: boolean ) { this._super = esSuper };
    public get super(): boolean { return this._super };

    public set resetear( resetear: boolean ) { this._resetear = resetear };
    public get resetear(): boolean { return this._resetear };

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'codigo', label: 'Codigo', type: 'text' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
        ]
    }

    async cargarDatos( objeto: Record<string, any> ) {
        this._codigo = objeto.codigo;
        this._idGrupoAcceso = objeto.id_grupo_acceso;
        this._nombreGrupoAcceso = objeto.grupo_acceso?.nombre;
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.empresa?.nombre;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.sucursal?.nombre;
        this._tipo = objeto.tipo;
        this._super = objeto.super;
        this._contrasenha = objeto.contrasenha;
        this._resetear = objeto.resetear;

    }

    override async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );
    }

    override async actualizarDatos( objeto: Record< string, any> ) {        
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("codigo", new FormControl(this._codigo, Validators.required));
        if ( !this.id ) {
            fg.addControl("contrasenha", new FormControl(this._contrasenha));
            fg.addControl("contrasenha2", new FormControl(this._contrasenha));
        }
        fg.addControl("id_grupo_acceso", new FormControl(this._idGrupoAcceso, Validators.required));
        fg.addControl("nombre_grupo_acceso", new FormControl(this._nombreGrupoAcceso));
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa, Validators.required));
        fg.addControl("id_sucursal", new FormControl(this._idSucursal, Validators.required));
        fg.addControl("nombre_sucursal", new FormControl(this._nombreSucursal, Validators.required));
        fg.addControl("tipo", new FormControl(this._tipo));
        fg.addControl("super", new FormControl(this._super));
        fg.addControl("resetear", new FormControl(this._resetear));
        return fg;
    }

    override async guardar( service: UsuarioService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    override async actualizar( service: UsuarioService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    override async eliminar( service: UsuarioService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}